import RAPIER from '@dimforge/rapier3d-compat'

/**
 * コライダーの役割。Roblox の CanCollide / CanTouch の組み合わせを表す。
 * - solid:  衝突する（CanCollide=true）。Touched も発火する（CanTouch 既定 true）。
 * - sensor: 衝突しないがすり抜け接触は検知する（CanCollide=false かつ CanTouch=true）。
 * - off:    衝突も接触もしない（CanCollide=false かつ CanTouch=false）。
 */
export type ColliderMode = 'solid' | 'sensor' | 'off'

export const colliderModeFor = (
  canCollide: boolean,
  canTouch: boolean,
): ColliderMode =>
  canCollide ? 'solid'
  : canTouch ? 'sensor'
  : 'off'

/**
 * sensor コライダーの重なり検知対象。アバターは kinematic、部品は fixed（isStatic）
 * （アバターのみ kinematic）だが、rapier の既定（DEFAULT）は DYNAMIC_* ペアしか狭域判定
 * しないため、kinematic アバター × fixed/kinematic sensor の重なりが
 * intersectionPairsWith に列挙されず Touched が発火しない。sensor の間だけ
 * KINEMATIC_FIXED / KINEMATIC_KINEMATIC を加えて検知できるようにする。
 */
export const SENSOR_ACTIVE_COLLISION_TYPES =
  RAPIER.ActiveCollisionTypes.DEFAULT |
  RAPIER.ActiveCollisionTypes.KINEMATIC_FIXED |
  RAPIER.ActiveCollisionTypes.KINEMATIC_KINEMATIC

/**
 * コライダーへモードを反映する。多数コライダーで毎フレーム呼ぶと rapier WASM が
 * 破綻し得るため、呼び出し側は前回モードからの変化時のみ呼ぶ（差分キャッシュ）。
 */
export const applyColliderMode = (
  collider: RAPIER.Collider,
  mode: ColliderMode,
): void => {
  if (mode === 'off') {
    collider.setEnabled(false)
    return
  }
  collider.setSensor(mode === 'sensor')
  // solid へ戻ったら既定へ戻す（solid で KINEMATIC_* ペアを残すと、静的な床・壁
  // 全数とアバターの狭域判定が常時走り、多数コライダー時の無駄が大きいため）。
  collider.setActiveCollisionTypes(
    mode === 'sensor' ?
      SENSOR_ACTIVE_COLLISION_TYPES
    : RAPIER.ActiveCollisionTypes.DEFAULT,
  )
  collider.setEnabled(true)
}
